/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Delivery_TripsInputs */

const vi_nav_delivery_trips = /** @type {(inputs: Nav_Delivery_TripsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyến giao`)
};

/**

* @param {Nav_Delivery_TripsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_delivery_trips = /** @type {((inputs?: Nav_Delivery_TripsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Delivery_TripsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_delivery_trips(inputs)
});